const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/customers`,
    search: `${API_URL}/customer/search`,
    information: `${API_URL}/customer/information`
};

export default apiUrls;
